var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",class:_vm.$style.container},[_vm._t("target"),_c('transition',{attrs:{"name":_vm.$style.slideTransition},on:{"after-enter":_vm.handleTransitionEnd}},[(_vm.dropDownVisible)?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.hideList),expression:"hideList"}],class:[_vm.$style.dropDownContainer, {
        [_vm.$style.dropDownContainerAlignRight]: _vm.dropDownAlignRight,
      }],style:({
        ...(_vm.dropDownMaxHeight && { maxHeight: _vm.dropDownMaxHeight }),
        ...(_vm.dropDownMaxWidth && { maxWidth: _vm.dropDownMaxWidth }),
      })},[_vm._t("dropDown")],2):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }